"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CurrentlyOpenLabel;

var _react = _interopRequireDefault(require("react"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var OPEN_STATUS = 'open';
var CLOSED_STATUS = 'closed';
var CLOSING_SOON_STATUS = 'closing_soon';
/**
 * Returns null if it's not today or no timezone is set, else Open or Closed.
 * Inspired on https://stackoverflow.com/a/59492313
 *
 * Assumes all hours[i].day are the same
 */

function CurrentlyOpenLabel(_ref) {
  var hours = _ref.hours,
      timezone = _ref.timezone; // Can't be totally sure without a timezone,
  // so don't do this if we don't have one.

  if (!timezone || hours.length === 0) {
    return null;
  } // If weekday isn't today.


  var now = _momentTimezone["default"].tz(timezone);

  var weekDayIso = now.isoWeekday();

  if (weekDayIso !== hours[0].day) {
    return null;
  }

  var allHourStatus = hours.map(function (hour) {
    var open = hour.open,
        close = hour.close;
    var openTimeString = open.toString().padStart(4, '0');

    var openMoment = _momentTimezone["default"].tz(openTimeString, 'hmm', timezone);

    var closeTimeString = close.toString().padStart(4, '0');

    var closeMoment = _momentTimezone["default"].tz(closeTimeString, 'hmm', timezone);

    var hourStatus = CLOSED_STATUS;

    if (closeMoment.isBefore(openMoment) || openMoment.isSame(closeMoment)) {
      // Handle ranges that span over midnight
      if (now.isAfter(openMoment)) {
        hourStatus = OPEN_STATUS;
      }
    } else if (now.isBetween(openMoment, closeMoment, null, '[)')) {
      // Normal range check using an inclusive start time and exclusive end time
      hourStatus = OPEN_STATUS;

      if (closeMoment.diff(now, 'minutes') <= 15) {
        hourStatus = CLOSING_SOON_STATUS;
      }
    }

    return hourStatus;
  });

  if (allHourStatus.includes(OPEN_STATUS)) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Open");
  }

  if (allHourStatus.includes(CLOSING_SOON_STATUS)) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Closing soon");
  }

  return /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: 'red'
    }
  }, "Closed");
}